import { get } from './http-methods';

export default {
  async getAppVersion() {
    try {
      const { json: { data } } = await get('/meta/version');

      return data;
    } catch (error) {
      console.error('[getAppVersion]:', error);
    }
  },
};
